import { observeIntersection } from '@/helpers/intersection-observer'

const defaults = {
  src: '',
  root: null,
  rootMargin: '100%',
  threshold: '0',
}

// root, rootMargin and threshold are Intersection Observer options
// Read more about them here: https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API

/**
 * Initialize module
 *
 * @param {object} options (1-1) - Override default settings with options object.
 * @param {string} options.src (1-1) - Path to image.
 * @param {string} options.root (0-1) - Defaults to the browser viewport if not specified or if null
 * @param {string} options.rootMargin (0-1) - Margin the image gets loaded before the actual intersection
 * @param {string} options.threshold (0-1) - The degree of intersection between the target element and its root (0 - 1). Threshold of 1.0 means that when 100% of the target is visible within the element specified by the root option, the callback is invoked
 *
 */

export default {
  update: (el, binding) => {
    // Only update IntersectionObserver if source was changed
    if (!binding.value || binding.value.src === binding.oldValue.src) return

    const options = { ...defaults, ...binding.value }

    function loadImage() {
      el.nodeName === 'IMG'
        ? (el.src = options.src) // Case 1: normal image
        : (el.style.backgroundImage = `url(${options.src})`) // Case 2: background image
    }

    observeIntersection(el, loadImage, options)
  },
}
